import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'
import Divider from '@mui/material/Divider'
import { ListItemButton, ListItemIcon } from '@mui/material'
import { Link } from 'react-router-dom'
import ListItemText from '@mui/material/ListItemText'
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import React from 'react'
import { sidebarFooterIconSx, sidebarTextColor } from './sidebarStyles'
import { styled } from '@mui/material'
import { ActivityRouteBuilder } from '../../../pages/routeParams'
import { useCompanyDetailsContext } from '../../../utils/hooks/useCompanyDetailsContext'

const DivSidebarFooter = styled('div')(() => ({
  marginTop: 'auto',

  '& span': {
    color: sidebarTextColor,
    textTransform: 'uppercase',
    fontSize: '1.2rem',
  },
}))

export const SidebarFooter = (): JSX.Element => {
  const { company } = useCompanyDetailsContext()
  const t = useAppTranslations()

  return (
    <DivSidebarFooter>
      <Divider />
      <ListItemButton component={Link} to={ActivityRouteBuilder(company.type.toLocaleLowerCase(), company.slug)}>
        <ListItemIcon sx={sidebarFooterIconSx}>
          <DynamicFeedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t('layout.sidebar.feed')}</ListItemText>
      </ListItemButton>
      <Divider />
      <ListItemButton component="a" href="https://docs.powerspace.com/docs" target="_blank">
        <ListItemIcon sx={sidebarFooterIconSx}>
          <MenuBookIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t('layout.sidebar.documentation')}</ListItemText>
      </ListItemButton>
    </DivSidebarFooter>
  )
}
